import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_SIDE_NAV_REDESIGN = registerFeatureWithDescription({
    numericalId: 402,
    id: "side-nav-redesign",
    name: "Side Navigation Redesign",
    internalUseOnly: true,
    descriptionLines: [
        "Replaces the left-hand navigation with the redesigned collapsible rail.",
        "Covers the company and application switchers, the skip link, and the mobile navigation toggle.",
    ],
})
